var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag",attrs:{"id":_vm.id || 'drag'}},[_vm._t("default",function(){return [_vm._v("empty")]},{"id":"child"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }